import { render, staticRenderFns } from "./PlanPageSupports.vue?vue&type=template&id=0c3a0d1a&scoped=true&"
import script from "./PlanPageSupports.vue?vue&type=script&lang=js&"
export * from "./PlanPageSupports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a0d1a",
  null
  
)

export default component.exports